import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import QCPanel from "./pages/QCPanel";
import QCPanelB from "./pages/QCPanelB";
import QCTeamLeadDashboard from "./pages/QCTeamlead";
import EditTransaction from "./pages/EditTransaction";
import ViewTransaction from "./pages/ViewTransaction.js";
import PanelD from "./pages/QCPanelD.js";
import Login from "./pages/Login"; // Import Login component
import LoginM from "./pages/LoginMicro";
import { UserProvider } from "./context/UserContext"; // Import the UserProvider
import { useParams } from "react-router-dom";
import QCPanelC from "./pages/QCPanelC.js";

function App() {
  return (
    <UserProvider>
      <Router>
        <Routes>
          {/* Login route */}
          <Route path="/" element={<LoginM />} />
          <Route path="/login" element={<LoginM />} />

          {/* QC Panel for Team lead */}
          <Route path="/teamlead" element={<QCTeamLeadDashboard />} />

          {/* QC Panel for Team A */}
          <Route path="/teamA" element={<QCPanel />} />

          {/* QC Panel for Team B */}
          <Route path="/teamB" element={<QCPanelB />} />

          {/* QC Panel for Team C */}
          <Route path="/teamC" element={<QCPanelC />} />

          {/* QC Panel for Team D */}
          <Route path="/teamD" element={<PanelD />} />

          {/* Edit Transaction route */}
          <Route
            path="/edit-transaction/:transactionId" // Dynamic route with parameter
            element={<EditTransactionWrapper />} // Use wrapper to pass transactionId prop
          />

          {/* View Transaction route */}
          <Route
            path="/view-transaction/:transactionId"
            element={<ViewTransactionWrapper />}
          />
        </Routes>
      </Router>
    </UserProvider>
  );
}

// Wrapper to extract transactionId from URL and pass to EditTransaction component
function EditTransactionWrapper() {
  const { transactionId } = useParams(); // Extract transactionId from the URL
  return <EditTransaction transactionId={transactionId} />; // Pass it as a prop
}

function ViewTransactionWrapper() {
  const { transactionId } = useParams(); // Extract transactionId from the URL
  return <ViewTransaction transactionId={transactionId} />; // Pass it as a prop
}

export default App;
